var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "workflow-summary" },
    [
      _c(
        "aside",
        { staticClass: "actions" },
        [
          _vm.isTerminateShown
            ? _c("button-fill", {
                attrs: {
                  color: "secondary",
                  disabled: _vm.isTerminateDisabled,
                  "disabled-label": _vm.terminateDisabledLabel,
                  label: "TERMINATE"
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.$modal.show("confirm-termination")
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("modal", { attrs: { name: "confirm-termination" } }, [
        _c("h3", [_vm._v("Are you sure you want to terminate this workflow?")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.terminationReason,
              expression: "terminationReason"
            }
          ],
          attrs: { placeholder: "Reason" },
          domProps: { value: _vm.terminationReason },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.terminationReason = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "footer",
          [
            _c("button-fill", {
              attrs: {
                color: "secondary",
                label: "TERMINATE",
                name: "button-terminate"
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.terminate.apply(null, arguments)
                }
              }
            }),
            _vm._v(" "),
            _c("button-fill", {
              attrs: {
                color: "primary",
                label: "CANCEL",
                name: "button-cancel"
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.$modal.hide("confirm-termination")
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.workflow
        ? _c("dl", [
            _vm.workflow.workflowExecutionInfo.isArchived
              ? _c("div", [
                  _c("h5", [_vm._v("Workflow archived")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n        This workflow has been retrieved from archival. Some summary\n        information may be missing.\n      "
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "workflow-name" }, [
              _c("dt", [_vm._v("Workflow Name")]),
              _vm._v(" "),
              _c("dd", [
                _vm._v(_vm._s(_vm.workflow.workflowExecutionInfo.type.name))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "started-at" }, [
              _c("dt", [_vm._v("Started At")]),
              _vm._v(" "),
              _c("dd", [_vm._v(_vm._s(_vm.workflowStartTime))])
            ]),
            _vm._v(" "),
            _vm.workflowCloseTime
              ? _c("div", { staticClass: "close-time" }, [
                  _c("dt", [_vm._v("Closed Time")]),
                  _vm._v(" "),
                  _c("dd", [_vm._v(_vm._s(_vm.workflowCloseTime))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "workflow-status",
                attrs: {
                  "data-status":
                    _vm.wfStatus !== undefined &&
                    (typeof _vm.wfStatus === "string"
                      ? _vm.wfStatus
                      : _vm.wfStatus.status)
                }
              },
              [
                _c("dt", [_vm._v("Status")]),
                _vm._v(" "),
                _c(
                  "dd",
                  [
                    _vm.wfStatus === "running" ? _c("bar-loader") : _vm._e(),
                    _vm._v(" "),
                    typeof _vm.wfStatus === "string"
                      ? _c("span", [_vm._v(_vm._s(_vm.wfStatus))])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.wfStatus !== undefined && _vm.wfStatus.to
                      ? _c("router-link", { attrs: { to: _vm.wfStatus.to } }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.wfStatus.text) +
                              "\n        "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _vm.result
              ? _c("div", { staticClass: "workflow-result" }, [
                  _c("dt", [_vm._v("Result")]),
                  _vm._v(" "),
                  _c(
                    "dd",
                    [
                      _c("data-viewer", {
                        attrs: {
                          item: _vm.result,
                          title: _vm.displayWorkflowId + " Result"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "workflow-id" }, [
              _c("dt", [_vm._v("Workflow Id")]),
              _vm._v(" "),
              _c("dd", [_vm._v(_vm._s(_vm.displayWorkflowId))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "run-id" }, [
              _c("dt", [_vm._v("Run Id")]),
              _vm._v(" "),
              _c("dd", [_vm._v(_vm._s(_vm.runId))])
            ]),
            _vm._v(" "),
            _vm.parentWorkflowRoute
              ? _c("div", { staticClass: "parent-workflow" }, [
                  _c("dt", [_vm._v("Parent Workflow")]),
                  _vm._v(" "),
                  _c(
                    "dd",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: _vm.parentWorkflowRoute.to } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.parentWorkflowRoute.text) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.cronSchedule
              ? _c("div", { staticClass: "cron-schedule" }, [
                  _c("dt", [_vm._v("Cron Schedule")]),
                  _vm._v(" "),
                  _c("dd", [_vm._v(_vm._s(_vm.cronSchedule))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "task-list" }, [
              _c("dt", [_vm._v("Task List")]),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "task-list",
                          params: {
                            clusterName: _vm.clusterName,
                            taskList:
                              _vm.workflow.executionConfiguration.taskList.name
                          }
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.workflow.executionConfiguration.taskList.name
                          ) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "history-length" }, [
              _c("dt", [_vm._v("History Events")]),
              _vm._v(" "),
              _c("dd", [
                _vm._v(_vm._s(_vm.workflow.workflowExecutionInfo.historyLength))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "workflow-input" }, [
              _c("dt", [_vm._v("Input")]),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _vm.input !== undefined
                    ? _c("data-viewer", {
                        attrs: {
                          item: _vm.input,
                          title: _vm.displayWorkflowId + " Input"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.workflow.pendingActivities
              ? _c(
                  "div",
                  { staticClass: "pending-activities" },
                  [
                    _c("dt", [_vm._v("Pending Activities")]),
                    _vm._v(" "),
                    _vm._l(_vm.workflow.pendingActivities, function(pa) {
                      return _c(
                        "dd",
                        { key: pa.activityID },
                        [_c("detail-list", { attrs: { item: pa } })],
                        1
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad4afe76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad4afe76","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/workflow/summary.vue
// module id = 1776
// module chunks = 0